import {
  Box,
  Flex,
  Stack,
} from '@chakra-ui/react';
import React, {
  useEffect,
} from 'react';
import { useForm } from 'react-final-form';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import BusinessDetailsView from '../BusinessDetailsView';
import BackButton from '../form/BackButton';
import MainButton from '../form/MainButton';
import QuestionsView from '../QuestionsView';

const BusinessDetailsSection = ({ config, onBack }: {
  config: IntakeConfig,
  onBack: () => void,
}) => {
  // @ts-ignore
  return (
    <Flex gap="1em" alignItems="center">
      <Stack direction="column" spacing={8} w="100%">
        <BackButton onClick={onBack}>Back</BackButton>
        <Box width={{ base: '100%', lg: '66%' }}>
          <BusinessDetailsView />
        </Box>
        <QuestionsView
          config={config}
        />
        <MainButton type="submit">Go to billing</MainButton>
      </Stack>
    </Flex>
  );
};

export default BusinessDetailsSection;
